import React , {useEffect} from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";



const SuccessPartners = () => {

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);


  return (
    <div className="section success_partners container-mid">

    <div className="d-flex-c" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline">  شركاء النجاح  </h1>
</div>

   <div className="sucess_foundations d-flex-c f-wrap flex-row mt-3">


    <img src="/images/partenrs/2.png" alt="" className="single_sucess_foundation" data-aos="zoom-out" data-aos-duration="290"   data-aos-easing="ease-in-quad" data-aos-mirror="true" />
    <img src="/images/partenrs/3.png" alt="" className="single_sucess_foundation" data-aos="zoom-out" data-aos-duration="320"   data-aos-easing="ease-in-quad" data-aos-mirror="true" />
    <img src="/images/partenrs/4.png" alt="" className="single_sucess_foundation" data-aos="zoom-out" data-aos-duration="350"   data-aos-easing="ease-in-quad" data-aos-mirror="true" />
    <img src="/images/partenrs/5.png" alt="" className="single_sucess_foundation" data-aos="zoom-out" data-aos-duration="390"   data-aos-easing="ease-in-quad" data-aos-mirror="true" />

   </div>

    </div>
  )
}

export default SuccessPartners